<script setup lang="ts">
import { Check, Xmark } from "@iconoir/vue";
import { SwitchRoot, SwitchThumb } from "reka-ui";

defineProps<{
  id: string;
  value: boolean;
  label: string;
}>();

const emit = defineEmits<{
  checked: [];
  unchecked: [];
}>();

function update(state: boolean) {
  if (state) emit("checked");
  else emit("unchecked");
}
</script>

<template>
  <div class="switch-button">
    <SwitchRoot
      :id
      v-slot="{ checked }"
      class="switch-root"
      :model-value="value"
      @update:model-value="update"
    >
      <SwitchThumb class="switch-thumb">
        <Check v-if="checked" /><Xmark v-else
      /></SwitchThumb>
    </SwitchRoot>
    <label :for="id">{{ label }} </label>
  </div>
</template>

<style scoped>
.switch-button {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}
.switch-root {
  block-size: 1.5rem;
  aspect-ratio: 2 / 1;
  border-radius: var(--border-radius-lg);
  border: solid var(--border-width) var(--grey-950);
  background-color: var(--bg-color-switch);
  cursor: pointer;
}

.switch-thumb {
  display: flex;
  border-radius: 50%;
  block-size: 100%;
  aspect-ratio: 1 / 1;

  transition:
    transform 0.2s,
    background-color 0.5s;

  > svg {
    block-size: 100%;
    inline-size: 100%;
  }

  &[data-state="unchecked"] {
    color: var(--text-color-switch-thumb-unchecked);
    background-color: var(--bg-color-switch-thumb-unchecked);
  }

  &[data-state="checked"] {
    transform: translateX(calc(100% + var(--border-width)));
    color: var(--text-color-switch-thumb-checked);
    background-color: var(--bg-color-switch-thumb-checked);
  }
}
label {
  margin-bottom: unset;
}
</style>
